<template>
    <div>
        <div class="dialog-container" :class="{ 'mobile-dialog-container': isMobile }" v-if="isShow">
            <div class="container">
                <div class="title">绑定手机号</div>
                <div class="form">
                    <div class="item">
                        <input v-model.trim="telNo" placeholder="请输入您的手机号" />
                    </div>
                    <div class="item">
                        <input v-model.trim="code" placeholder="请输入验证码" />
                        <div class="code-btn" :class="hasGetCode ? '' : 'disabled-state'" @click="onCheckTel">
                            {{ hasGetCode ? '获取验证码' : `${timeNum}s` }}
                        </div>
                    </div>
                </div>
                <div class="submit-btn" @click="onSubmit">绑 定</div>
                <div class="desc">根据国家法律要求互联网账号实名认证<br />为保障账号正常使用，请完成手机号绑定</div>
            </div>
        </div>

        <div
            class="dialog-container-verification"
            :class="{ 'mobile-dialog-container-verification': isMobile }"
            v-if="isShowVerificationPopup"
        >
            <div class="container">
                <div class="verification">
                    <img
                        @click="onResetNum"
                        class="verification-img"
                        :src="`${numVerificationUrl}${telNo}&rd=${numVerificationRd}`"
                    />
                    <van-icon @click="onResetNum" name="replay" />
                    <input v-model="numVerification" placeholder="请输入" />
                </div>
                <div class="opts">
                    <div class="close-btn" @click="isShowVerificationPopup = false">取消</div>
                    <div class="submit-btn" @click="onGetCaptcha">确认</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { userTelMod, getCaptcha } from '@/utils/api'
import { setUserInfo, getUserInfo } from '@/utils/login.js'

let timer = null
const setIntervalTime = 60
export default {
    props: ['isShow', 'isMobile'],
    data() {
        return {
            telNo: '',
            code: '',
            timeNum: setIntervalTime,
            hasGetCode: true,

            isShowVerificationPopup: false,
            numVerification: '',
            numVerificationUrl: '',
            numVerificationRd: 1,
        }
    },
    mounted() {
        this.numVerificationUrl = `${window.SEVER_PATH}/user/getKaptcha?tel=`
    },
    methods: {
        onResetNum() {
            this.numVerificationRd += 1
        },
        onGetCaptcha() {
            getCaptcha({
                tel: this.telNo,
                kaptcha: this.numVerification,
            }).then(() => {
                this.$toast.success('发送成功')
                this.isShowVerificationPopup = false
                this.onSendSuccess()
            })
        },
        onCheckTel() {
            const rule = new RegExp(/^1[0-9]{10}$/)
            if (!rule.test(this.telNo)) {
                return this.$toast('请输入正确的手机号')
            }
            if (!this.hasGetCode) return
            this.isShowVerificationPopup = true
            this.numVerification = ''
        },
        onSendSuccess() {
            this.hasGetCode = false
            timer = setInterval(() => {
                this.timeNum -= 1
                if (this.timeNum <= 0) {
                    clearInterval(timer)
                    timer = null
                    this.hasGetCode = true
                    this.timeNum = setIntervalTime
                }
            }, 1000)
        },
        onSubmit() {
            var ruleTel = new RegExp(/^1[0-9]{10}$/)
            var ruleCode = new RegExp(/^[0-9]{4,8}$/)
            if (!ruleTel.test(this.telNo)) {
                return this.$toast('请输入正确的手机号')
            } else if (!ruleCode.test(this.code)) {
                return this.$toast('请输入正确的验证码')
            }
            const userInfo = getUserInfo()

            userTelMod({
                userId: userInfo.id,
                telNo: this.telNo,
                captcha: this.code,
            }).then(() => {
                userInfo.telNo = this.telNo
                setUserInfo(userInfo)
                this.$toast({ className: 'success-toast', message: '绑定成功' })
                this.$emit('authSuccess')
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.dialog-container-verification,
.dialog-container {
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.8);
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}
.dialog-container-verification {
    z-index: 1002;
}

.dialog-container {
    .container {
        background: #fff;
        font-size: 14px;
        width: 400px;
        height: 300px;
        border-radius: 4px;
        .title {
            height: 20px;
            font-size: 20px;
            color: #33312f;
            line-height: 20px;
            padding: 32px;
            text-align: center;
        }
        .item {
            width: 352px;
            height: 36px;
            background: #ffffff;
            border-radius: 2px;
            border: 1px solid #e6e6e6;
            box-sizing: border-box;
            margin: 0 auto;
            position: relative;
            margin-bottom: 20px;
        }
        input {
            width: 80%;
            height: 100%;
            font-size: 16px;
            color: #33312f;
            line-height: 24px;
            padding: 6px 30px 6px 12px;
            box-sizing: border-box;
            background: none;
            border: none;
        }
        .code-btn {
            width: 96px;
            height: 100%;
            background: #44cd94;
            border-radius: 0px 2px 2px 0px;
            font-size: 14px;
            color: #ffffff;
            line-height: 14px;
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            right: 0;
            top: 0;
            cursor: pointer;
        }
        .disabled-state {
            color: #666666;
            background: #eeeeee;
        }
        .submit-btn {
            color: #ffffff;
            background: #44cd94;
            width: 100px;
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            font-weight: 700;
            font-size: 14px;
            color: #ffffff;
            margin: 42px auto 8px;
            cursor: pointer;
            &:active {
                opacity: 0.94;
            }
        }
        .desc {
            font-size: 12px;
            color: #888;
            line-height: 1.4em;
            padding: 0 40px;
            text-align: center;
        }
    }
}

.mobile-dialog-container {
    .container {
        width: 300px;
        height: 240px;
        .title {
            font-size: 18px;
            line-height: 1em;
            height: 1em;
            padding: 16px;
        }
        .item {
            width: 240px;
            height: 32px;
            margin-bottom: 16px;
        }
        input {
            height: 32px;
            font-size: 14px;
            line-height: 32px;
        }
        .code-btn {
            width: 96px;
        }

        .submit-btn {
            width: 90px;
            height: 28px;
            font-size: 13px;
            font-weight: 500;
            border-radius: 2px;
            margin: 32px auto 8px;
        }
    }
}

.dialog-container-verification {
    .container {
        background: #fff;
        font-size: 14px;
        width: 400px;
        height: 190px;
        border-radius: 4px;
        .verification {
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 40px auto 10px;
            .verification-img {
                width: 88px;
                height: 32px;
                margin-right: 10px;
            }
            .van-icon-replay {
                cursor: pointer;
                font-size: 18px;
            }
            input {
                margin-left: 40px;
                height: 32px;
                width: 120px;
                border: 1px solid #dedede;
                display: block;
                border-radius: 4px;
                padding: 4px 8px;
                text-align: center;
            }
        }
        .opts {
            display: flex;
            justify-content: space-between;
            padding: 0 72px 0;
            .close-btn,
            .submit-btn {
                color: #ffffff;
                background: #44cd94;
                width: 100px;
                height: 36px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 4px;
                font-weight: 700;
                font-size: 14px;
                color: #ffffff;
                margin: 42px auto 8px;
                cursor: pointer;
                &:active {
                    opacity: 0.94;
                }
            }
            .close-btn {
                border: 1px solid #e6e6e6;
                background: #ffffff;
                color: #606266;
            }
        }
    }
}
.mobile-dialog-container-verification {
    .container {
        width: 300px;
        height: 180px;
        .verification {
            margin: 36px auto 10px;
            .verification-img {
                width: 100px;
                height: 40px;
            }
            input {
                margin-left: 24px;
                height: 28px;
                width: 80px;
            }
        }
        .opts {
            padding: 0 32px;
        }
    }
}
</style>
